import { SERVICE_DESSK_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { IServiceDeskTicketResponse, IServiceDeskTicketResponseData } from "@/api_framework/api_modals/ServiceDesk";
import { IServiceTicketList } from "@/app/components/routes/auth_routes/VeticServiceDesk/ServiceDeskissueList";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useServiceDeskTicketListAPI = () => {
  const [ticketList, setTicketList] = useState<IServiceDeskTicketResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (filterParams: IServiceTicketList) => {
      dispatch(
        setLoading({
          key: "isServiceDeskTicketList",
          status: true,
        }),
      );

      let API_FLAGE = null;
      if (filterParams?.search_keyword) {
        API_FLAGE = `${SERVICE_DESSK_APIS?.SERVICE_DESK_TICKET_LIST?.baseURL}?search_keyword=${filterParams?.search_keyword}`;
      } else if (filterParams?.customer_user_id) {
        API_FLAGE = `${SERVICE_DESSK_APIS?.SERVICE_DESK_TICKET_LIST?.baseURL}?customer_user_id=${filterParams?.customer_user_id}`;
      } else {
        API_FLAGE = `${SERVICE_DESSK_APIS?.SERVICE_DESK_TICKET_LIST?.baseURL}?creation_date=${filterParams?.creation_date}&vetic_status=${filterParams?.vetic_status}`;
      }

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(API_FLAGE, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IServiceDeskTicketResponse>) => {
            if (res.data?.status) {
              setTicketList(res.data.data);
              dispatch(
                setLoading({
                  key: "isServiceDeskTicketList",
                  status: false,
                }),
              );
            } else {
              setTicketList([]);
              dispatch(
                setLoading({
                  key: "isServiceDeskTicketList",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isServiceDeskTicketList",
                status: false,
              }),
            );
            setTicketList([]);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              toast.error("Error while fetching Issues");
            }
            if (e.status === 400) {
              toast("Issues records not found");
            }
            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isServiceDeskTicketList",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
        setTicketList([]);
      }
    },
    [dispatch],
  );
  return { execute, ticketList };
};
